// prepareParseObject.js

import logger from "./logger"; // Предполагаем, что logger доступен

export const prepareParseObject = (ad) => {
     logger.log('prepareParseObject ad:', ad);
    const po = { details: {} };
    const unprocessedFieldsInfo = []; // Для сбора информации о полях, которые не удалось обработать

    // --- Общие поля, которые ты просил не трогать или уже есть ---
    po.photos = ad.images || []; // Фотографии объекта
    po.importSource = {
        sourceId: ad.source_id,
        externalListingId: ad.avitoid,
        ...(ad.url ? { sourceUrl: ad.url } : {}),
    };
    // layout_photo - нет информации в API для автоматического разделения фото планировки
    if (!ad.images || ad.images.length === 0) {
        unprocessedFieldsInfo.push({ field: "photo / layout_photo", reason: "Нет изображений (ad.images пуст или отсутствует)." });
    } else {
        // Если в будущем появится способ различать фото и планировки, логика будет здесь
        // Пока все фото идут в 'photo'
    }

    po.description = ad.description || ""; // Описание объекта

    po.addressNoUse = ad.address || "";

    // Формирование commentforme
    let commentformeParts = [];
    if (ad.person) commentformeParts.push(ad.person);
    if (ad.phone && ad.phone !== "00000000000") commentformeParts.push(ad.phone);
    if (ad.person_type) commentformeParts.push(ad.person_type);
    else if (ad.person_type_id === 1) commentformeParts.push('Частное лицо');
    else if (ad.person_type_id === 2) commentformeParts.push('Агентство');
    else if (ad.person_type_id === 3) commentformeParts.push('Частное лицо (фильтр)');

    po.details.commentforme = commentformeParts.join(' ');

    if (ad.time_source_created) {
        po.details.commentforme += '\nОбъявление создано: ' + ad.time_source_created;
    }
    if (ad.source) {
        po.details.commentforme += '\nИсточник: ' + ad.source;
    }
    if (ad.url) {
        po.details.commentforme += '\nСсылка на объявление: ' + ad.url;
    }
    // --- Конец общих полей ---

    // Вспомогательная функция для безопасного получения значений из params2
    const getP2Val = (objPath) => {
        if (!ad.params2 || typeof ad.params2 !== 'object') return undefined;
        const pathParts = objPath.split('.');
        let current = ad.params2;
        for (const part of pathParts) {
            if (current && typeof current === 'object' && part in current) {
                current = current[part];
            } else {
                return undefined;
            }
        }
        return current;
    };

    // Вспомогательная функция для преобразования в число или добавления в unprocessed
    const parseFloatOrLog = (value, fieldName, detailObj) => {
        if (value === undefined || value === null || String(value).trim() === "") return undefined;
        const num = parseFloat(String(value).replace(/[^\d.]/g, '').replace(',', '.'));
        if (isNaN(num)) {
            unprocessedFieldsInfo.push({ field: fieldName, value: value, reason: "Не удалось преобразовать в число." });
            return undefined;
        }
        detailObj[fieldName] = num;
        return num;
    };

    const parseIntOrLog = (value, fieldName, detailObj) => {
        if (value === undefined || value === null || String(value).trim() === "") return undefined;
        const num = parseInt(String(value).replace(/[^\d]/g, ''), 10);
        if (isNaN(num)) {
            unprocessedFieldsInfo.push({ field: fieldName, value: value, reason: "Не удалось преобразовать в целое число." });
            return undefined;
        }
        detailObj[fieldName] = num;
        return num;
    };


    // Только Квартиры (cat2_id === 2)
    if (ad.cat2_id === 2) {

        logger.log('Обработка Квартиры');

        po.details.jsonFileName = "apartment_ru_ru.json";
        po.details.subcategoryId = 643002;
        po.details.categoryId = 6430;
        // type - фиксированное поле для квартир
  /*       po.details.type = {
            fileName: "apartment_ru_ru.json",
            id: 643002,
            options: ["Квартира"],
            multiple: false,
            required: false
        }; */

        // _mainDealType (Сделка: Продажа / Аренда)
        if (ad.nedvigimost_type_id === 1 || String(ad.nedvigimost_type_id) === "1") {
            po.details._mainDealType = 1; // Продажа
        } else if (ad.nedvigimost_type_id === 2 || String(ad.nedvigimost_type_id) === "2") {
            po.details._mainDealType = 2; // Аренда
        } else {
            unprocessedFieldsInfo.push({ field: "_mainDealType", reason: `Неизвестный nedvigimost_type_id: ${ad.nedvigimost_type_id}. Объект может быть неполным.` });
            // Если это критично, можно здесь завершить обработку: return null;
        }

        // --- Поля, зависящие от _mainDealType и другие ---

        // apartment_type (Вторичка / Новостройка) - только для продажи
        if (po.details._mainDealType === 1) {
            if (ad.param_1957 === "Вторичка") {
                po.details.apartment_type = 1;
            } else if (ad.param_1957 === "Новостройка") {
                po.details.apartment_type = 2;
            } else if (ad.param_1957) {
                unprocessedFieldsInfo.push({ field: "apartment_type", value: ad.param_1957, reason: "Неизвестное значение для Вид объекта." });
            }
        }

        // _rent_type (Тип аренды) - только для аренды
        if (po.details._mainDealType === 2) {
            if (ad.param_2016 === "На длительный срок") {
                po.details._rent_type = 1; // Долгосрочная
            } else if (ad.param_2016 === "Посуточно") {
                po.details._rent_type = 2; // Посуточная
            } else if (ad.param_2016) {
                unprocessedFieldsInfo.push({ field: "_rent_type", value: ad.param_2016, reason: "Неизвестное значение для Срок аренды." });
            }
        }

        // floor (Этаж)
        let floorSource = po.details._mainDealType === 1 ? ad.param_2113 : ad.param_2315;
        const p2FloorInfo = getP2Val("О квартире.Этаж"); // Например, "2 из 12" или "3"
        if (p2FloorInfo) {
            const match = String(p2FloorInfo).match(/^(\d+)/); // Берем первое число
            if (match && match[1]) {
                floorSource = match[1];
            }
        }
        parseIntOrLog(floorSource, "floor", po.details);

        // total_floors (Этажность)
        let totalFloorsSource = po.details._mainDealType === 1 ? ad.param_2213 : ad.param_2415;
        let p2TotalFloorsFromHouse = getP2Val("О доме.Этажей в доме");
        if (p2TotalFloorsFromHouse) {
            totalFloorsSource = p2TotalFloorsFromHouse;
        } else if (p2FloorInfo) {
            const match = String(p2FloorInfo).match(/из\s*(\d+)/); // Берем число после "из"
            if (match && match[1]) {
                totalFloorsSource = match[1];
            }
        }
        parseIntOrLog(totalFloorsSource, "total_floors", po.details);

        // year_built (Год постройки) - только для продажи
        if (po.details._mainDealType === 1) {
            const p2YearBuilt = getP2Val("О доме.Год постройки");
            if (p2YearBuilt) {
                parseIntOrLog(p2YearBuilt, "year_built", po.details);
            } else if (po.details.apartment_type === 1 && ad.param_12867) {
                // param_12867 "Срок сдачи" для вторички может иногда означать год постройки.
                // Но в документации он под новостройками. Используем с осторожностью.
                // parseIntOrLog(ad.param_12867, "year_built", po.details);
                // Решено не использовать param_12867 для year_built вторички, т.к. он для новостроек.
                unprocessedFieldsInfo.push({ field: "year_built", reason: "Год постройки не найден в params2 для вторички, param_12867 не используется." });
            } else {
                unprocessedFieldsInfo.push({ field: "year_built", reason: "Не найдено в params2['О доме']['Год постройки']." });
            }
        }

        // ceiling_height (Высота потолков) - только для продажи
        if (po.details._mainDealType === 1) {
            const p2CeilingHeight = getP2Val("О квартире.Высота потолков"); // "3 м"
            if (p2CeilingHeight) {
                parseFloatOrLog(p2CeilingHeight, "ceiling_height", po.details);
            } else {
                unprocessedFieldsInfo.push({ field: "ceiling_height", reason: "Не найдено в params2['О квартире']['Высота потолков']." });
            }
        }

        // type_construction (Тип дома) - только для продажи
        if (po.details._mainDealType === 1) {
            const typeConstructionMap = {
                "кирпичный": 1, "монолитный": 2, "панельный": 3, "блочный": 4,
                "монолитно-кирпичный": 5, /* "сталинский": 6, */ "деревянный": 7
            };
            let typeConstructionSource = ad.param_2009; // Для продажи
            const p2TypeConstruction = getP2Val("О доме.Тип дома");
            if (p2TypeConstruction) typeConstructionSource = p2TypeConstruction;

            if (typeConstructionSource) {
                const tcKey = String(typeConstructionSource).toLowerCase();
                if (typeConstructionMap[tcKey]) {
                    po.details.type_construction = typeConstructionMap[tcKey];
                } else {
                    unprocessedFieldsInfo.push({ field: "type_construction", value: typeConstructionSource, reason: "Неизвестное значение." });
                }
            }
        }

        // roomsId (Количество комнат)
        let roomsSourceApi = po.details._mainDealType === 1 ? ad.param_1945 : ad.param_2019;
        const p2Rooms = getP2Val("О квартире.Количество комнат");
        if (p2Rooms !== undefined) roomsSourceApi = String(p2Rooms);

        if (roomsSourceApi !== undefined && roomsSourceApi !== null) {
            const roomsStr = String(roomsSourceApi).toLowerCase().trim();
            if (roomsStr === "студия") {
                po.details.roomsId = -1;
            } else if (roomsStr === "свободная планировка") { // В API нет, но на всякий случай
                po.details.roomsId = -2;
            } else {
                const numRooms = parseInt(roomsStr, 10);
                if (!isNaN(numRooms)) {
                    if (numRooms >= 1 && numRooms <= 6) {
                        po.details.roomsId = numRooms;
                    } else if (numRooms >= 7) {
                        po.details.roomsId = 7; // 7+
                    } else {
                        unprocessedFieldsInfo.push({ field: "roomsId", value: roomsSourceApi, reason: "Число комнат вне диапазона 1-7+." });
                    }
                } else {
                    unprocessedFieldsInfo.push({ field: "roomsId", value: roomsSourceApi, reason: "Не удалось определить количество комнат." });
                }
            }
        } else {
            unprocessedFieldsInfo.push({ field: "roomsId", reason: "Источник для количества комнат не найден." });
        }

        // total_area (Общая площадь)
        let totalAreaSource = po.details._mainDealType === 1 ? ad.param_2313 : ad.param_2515;
        const p2TotalArea = getP2Val("О квартире.Общая площадь");
        if (p2TotalArea) totalAreaSource = p2TotalArea;
        parseFloatOrLog(totalAreaSource, "total_area", po.details);

        // living_area (Жилая площадь) - не для посуточной аренды
        if (po.details._rent_type !== 2) {
            let livingAreaSource = po.details._mainDealType === 1 ? ad.param_12722 : ad.param_12724;
            const p2LivingArea = getP2Val("О квартире.Жилая площадь");
            if (p2LivingArea) livingAreaSource = p2LivingArea;
            parseFloatOrLog(livingAreaSource, "living_area", po.details);
        }

        // kitchen_area (Площадь кухни)
        let kitchenAreaSource = po.details._mainDealType === 1 ? ad.param_12721 : ad.param_12723;
        const p2KitchenArea = getP2Val("О квартире.Площадь кухни");
        if (p2KitchenArea) kitchenAreaSource = p2KitchenArea;
        parseFloatOrLog(kitchenAreaSource, "kitchen_area", po.details);

        // property_type (Тип недвижимости: Квартира / Апартаменты)
        po.details.property_type = 1; // По умолчанию "Квартира"
        const titleLower = (ad.title || "").toLowerCase();
        const descLower = (po.description || "").toLowerCase();
        if (titleLower.includes("апартамент") || descLower.includes("апартамент")) {
            po.details.property_type = 2; // Апартаменты
        }

        // guest_count (Количество гостей) - только для посуточной аренды
        if (po.details._mainDealType === 2 && po.details._rent_type === 2) {
            const p2GuestCount = getP2Val("О квартире.Спальные места") || getP2Val("О квартире.Количество спальных мест");
            if (p2GuestCount) {
                parseIntOrLog(p2GuestCount, "guest_count", po.details);
            } else {
                unprocessedFieldsInfo.push({ field: "guest_count", reason: "Не найдено в params2." });
            }
        }

        // balcony, loggia
        const p2BalconyLoggia = getP2Val("О квартире.Балкон или лоджия"); // "балкон", "лоджия", "2 балкона, лоджия"
        if (p2BalconyLoggia && typeof p2BalconyLoggia === 'string') {
            const blLower = p2BalconyLoggia.toLowerCase();
            if (blLower.includes("балкон")) {
                // Ищем число перед "балкон" или просто 1, если есть слово "балкон"
                const balconyMatch = blLower.match(/(\d+)\s*(балкон)/);
                po.details.balcony = balconyMatch && balconyMatch[1] ? parseInt(balconyMatch[1]) : 1;
            }
            if (blLower.includes("лоджия")) {
                const loggiaMatch = blLower.match(/(\d+)\s*(лоджия)/);
                po.details.loggia = loggiaMatch && loggiaMatch[1] ? parseInt(loggiaMatch[1]) : 1;
            }
        }

        // windows (Вид из окна)
        const p2Windows = getP2Val("О квартире.Окна"); // "на улицу, на солнечную сторону"
        if (p2Windows && typeof p2Windows === 'string') {
            po.details.windows = [];
            const windowsOptions = { "во двор": 1, "на улицу": 2, "на солнечную сторону": 3 };
            p2Windows.split(',').forEach(opt => {
                const optTrimmedLower = opt.trim().toLowerCase();
                if (windowsOptions[optTrimmedLower]) {
                    po.details.windows.push(windowsOptions[optTrimmedLower]);
                } else if (optTrimmedLower) {
                    unprocessedFieldsInfo.push({ field: "windows", value: optTrimmedLower, reason: "Неизвестная опция." });
                }
            });
            if (po.details.windows.length === 0) delete po.details.windows;
        }

        // appliances (Техника) - не для продажи
        if (po.details._mainDealType !== 1) {
            const p2Appliances = getP2Val("О квартире.Техника"); // "кондиционер, холодильник, ..."
            if (p2Appliances && typeof p2Appliances === 'string') {
                po.details.appliances = [];
                const appliancesMap = {
                    "кондиционер": 1, "холодильник": 2, "стиральная машина": 3,
                    "посудомоечная машина": 4, /*"интернет": 5,*/ "телевизор": 6, "водонагреватель": null // водонагреватель не мапим
                    // "Интернет" лучше через internet_phone
                };
                p2Appliances.split(',').forEach(item => {
                    const itemTrimmedLower = item.trim().toLowerCase();
                    if (appliancesMap[itemTrimmedLower]) {
                        po.details.appliances.push(appliancesMap[itemTrimmedLower]);
                    } else if (itemTrimmedLower === "интернет" || itemTrimmedLower === "wi-fi") {
                        // Обработаем ниже в internet_phone
                    } else if (itemTrimmedLower && appliancesMap[itemTrimmedLower] !== null) {
                        unprocessedFieldsInfo.push({ field: "appliances", value: itemTrimmedLower, reason: "Неизвестная техника." });
                    }
                });
                if (po.details.appliances.length === 0) delete po.details.appliances;
            }
        }

        // bathroom_separate, bathroom_combined (Санузел)
        const p2BathroomType = getP2Val("О квартире.Санузел"); // "совмещенный", "раздельный", "2 санузла"
        if (p2BathroomType && typeof p2BathroomType === 'string') {
            const btLower = p2BathroomType.toLowerCase();
            let count = 1;
            const countMatch = btLower.match(/(\d+)\s*(сануз)/);
            if (countMatch && countMatch[1]) {
                count = parseInt(countMatch[1]);
            }

            if (btLower.includes("совмещенный") || btLower.includes("совмещённый")) {
                po.details.bathroom_combined = count > 0 ? count : 1;
            }
            if (btLower.includes("раздельный")) {
                po.details.bathroom_separate = count > 0 ? count : 1;
            }
            // Если просто "2 санузла", без уточнения, сложно мапить.
            // Если "совмещенный" и "раздельный" не указаны, но есть число, можно попробовать распределить
            if (!po.details.bathroom_combined && !po.details.bathroom_separate && count > 1) {
                // Например, если "2 санузла", можно предположить 1 совмещенный и 1 раздельный, или 2 совмещенных. Неоднозначно.
                unprocessedFieldsInfo.push({ field: "bathroom_separate/combined", value: p2BathroomType, reason: "Неясно как распределить количество санузлов." });
            }
        }

        // renovation (Ремонт) - не для посуточной аренды
        if (po.details._rent_type !== 2) {
            const p2Renovation = getP2Val("О квартире.Ремонт");
            if (p2Renovation && typeof p2Renovation === 'string') {
                const renovationMap = {
                    "без ремонта": 1, "требует ремонта": 1,
                    "косметический": 2, "евро": 3, "дизайнерский": 4
                };
                const renKey = p2Renovation.toLowerCase();
                if (renovationMap[renKey]) {
                    po.details.renovation = renovationMap[renKey];
                } else {
                    unprocessedFieldsInfo.push({ field: "renovation", value: p2Renovation, reason: "Неизвестный тип ремонта." });
                }
            }
        }

        // passenger_lift, goods_lift (Лифты) - не для посуточной аренды
        if (po.details._rent_type !== 2) {
            const p2PassLift = getP2Val("О доме.Пассажирский лифт");
            if (p2PassLift && parseInt(p2PassLift) > 0) {
                po.details.passenger_lift = parseInt(p2PassLift);
            }
            const p2GoodsLift = getP2Val("О доме.Грузовой лифт");
            if (p2GoodsLift && parseInt(p2GoodsLift) > 0) {
                po.details.goods_lift = parseInt(p2GoodsLift);
            }
        }

        // entrance (Подъезд: Пандус, Мусоропровод)
        po.details.entrance = [];
        const p2InHouse = getP2Val("О доме.В доме"); // "консьерж, газ, мусоропровод"
        if (p2InHouse && typeof p2InHouse === 'string') {
            if (p2InHouse.toLowerCase().includes("мусоропровод")) {
                po.details.entrance.push(2); // Мусоропровод
            }
            // Пандус обычно указывается реже или в Дворе.
        }
        const p2Yard = getP2Val("О доме.Двор");
        if (p2Yard && typeof p2Yard === 'string') {
            if (p2Yard.toLowerCase().includes("пандус")) { // Добавим проверку на пандус во дворе
                if (!po.details.entrance.includes(1)) po.details.entrance.push(1); // Пандус
            }
        }
        if (po.details.entrance.length === 0) delete po.details.entrance;


        // parking (Парковка)
        const p2Parking = getP2Val("О доме.Парковка"); // "подземная, за шлагбаумом во дворе"
        if (p2Parking && typeof p2Parking === 'string') {
            po.details.parking = [];
            const parkingMap = {
                "наземная": 1, "открытая во дворе": 1, "за шлагбаумом во дворе": 1, "во дворе": 1,
                "многоуровневая": 2, "подземная": 3, "на крыше": 4
            };
            const parkItems = p2Parking.split(',').map(p => p.trim().toLowerCase());
            parkItems.forEach(item => {
                if (parkingMap[item] && !po.details.parking.includes(parkingMap[item])) {
                    po.details.parking.push(parkingMap[item]);
                } else if (item && parkingMap[item] === undefined) {
                    unprocessedFieldsInfo.push({ field: "parking", value: item, reason: "Неизвестный тип парковки." });
                }
            });
            if (po.details.parking.length === 0) delete po.details.parking;
        }

        // furniture (Мебель) - только для аренды
        if (po.details._mainDealType === 2) {
            const p2Furniture = getP2Val("О квартире.Мебель"); // "кухня, хранение одежды, спальные места"
            if (p2Furniture && typeof p2Furniture === 'string') {
                po.details.furniture = [];
                const furnItems = p2Furniture.toLowerCase().split(',').map(f => f.trim());
                let hasKitchen = false;
                let hasRoomFurniture = false;

                furnItems.forEach(item => {
                    if (item.includes("кухня")) hasKitchen = true;
                    if (item.includes("хранение одежды") || item.includes("спальные места") || item.includes("кровать") || item.includes("диван")) {
                        hasRoomFurniture = true;
                    }
                });

                if (hasKitchen) po.details.furniture.push(2); // На кухне
                if (hasRoomFurniture) po.details.furniture.push(3); // В комнатах

                if (po.details.furniture.length === 0 && p2Furniture.length > 0) { // Если что-то указано, но не смапилось
                    unprocessedFieldsInfo.push({ field: "furniture", value: p2Furniture, reason: "Мебель указана, но не удалось классифицировать." });
                } else if (po.details.furniture.length === 0 && (!p2Furniture || p2Furniture.trim() === "")) {
                    // Если поле params2 пусто или отсутствует, можно считать "Без мебели"
                    // po.details.furniture.push(1); // Без мебели - но это неявное предположение
                }
                if (po.details.furniture.length === 0) delete po.details.furniture;
            } else {
                // Если поле params2.Мебель отсутствует для аренды, можно ли считать "Без мебели"?
                // po.details.furniture = [1]; // Без мебели
                unprocessedFieldsInfo.push({ field: "furniture", reason: "Поле Мебель отсутствует в params2. 'Без мебели' не установлено." });
            }
        }

        // bathroom (Ванная комната: Ванна / Душевая кабина) - не для продажи
        if (po.details._mainDealType !== 1) {
            po.details.bathroom = [];
            // Ищем в описании санузла или в технике
            const p2Tech = getP2Val("О квартире.Техника") || "";
            const p2Sanuzel = getP2Val("О квартире.Санузел") || "";
            const combinedText = (p2Tech + " " + p2Sanuzel).toLowerCase();

            if (combinedText.includes("ванна") && !combinedText.includes("душевая кабина рядом с ванной")) {
                po.details.bathroom.push(1); // Ванна
            }
            if (combinedText.includes("душевая кабина") || combinedText.includes("душ. кабина") || combinedText.includes("душевая")) {
                po.details.bathroom.push(2); // Душевая кабина
            }
            if (po.details.bathroom.length === 0) delete po.details.bathroom;
        }

        // internet_phone (Связь: Интернет, Телефон) - для долгосрочной аренды
        if (po.details._mainDealType === 2 && po.details._rent_type === 1) {
            po.details.internet_phone = [];
            const p2Tech = getP2Val("О квартире.Техника") || "";
            const p2InHouse = getP2Val("О доме.В доме") || "";
            const combinedText = (p2Tech + " " + p2InHouse + " " + (po.description || "")).toLowerCase();

            if (combinedText.includes("интернет") || combinedText.includes("wi-fi") || combinedText.includes("вай-фай")) {
                po.details.internet_phone.push(1); // Интернет
            }
            if (combinedText.includes("телефон")) {
                po.details.internet_phone.push(2); // Телефон
            }
            if (po.details.internet_phone.length === 0) delete po.details.internet_phone;
        }

        // --- Поля для новостроек (apartment_type === 2) ---
        if (po.details._mainDealType === 1 && po.details.apartment_type === 2) {
            // sale_type_new_apart (Тип продажи для новостройки)
            const p2SaleTypeNew = getP2Val("О квартире.Способ продажи"); // Может содержать типы
            // В API нет прямого param для этого. Пробуем из params2["О квартире"]["Способ продажи"]
            // или "Тип договора" если есть.
            // "Договор уступки" -> 1, "Договор ЖСК" -> 2, "Свободная продажа" -> 3, "214-ФЗ" -> 4
            // "Договор инвестирования" -> 5, "Предварительный договор купли-продажи" -> 6
            if (p2SaleTypeNew && typeof p2SaleTypeNew === 'string') {
                const stnLower = p2SaleTypeNew.toLowerCase();
                if (stnLower.includes("уступки")) po.details.sale_type_new_apart = 1;
                else if (stnLower.includes("жск")) po.details.sale_type_new_apart = 2;
                else if (stnLower.includes("214-фз") || stnLower.includes("фз-214") || stnLower.includes("дду")) po.details.sale_type_new_apart = 4;
                else if (stnLower.includes("инвестирования")) po.details.sale_type_new_apart = 5;
                else if (stnLower.includes("предварительный договор")) po.details.sale_type_new_apart = 6;
                // "Свободная продажа" для новостройки - это немного странно, но если есть, то 3
                else if (stnLower.includes("свободная")) po.details.sale_type_new_apart = 3;
                else {
                    unprocessedFieldsInfo.push({ field: "sale_type_new_apart", value: p2SaleTypeNew, reason: "Не удалось определить тип продажи новостройки." });
                }
            } else {
                unprocessedFieldsInfo.push({ field: "sale_type_new_apart", reason: "Способ продажи для новостройки не найден." });
            }

            // completion_date (Срок сдачи дома)
            if (ad.param_12867) { // "Срок сдачи" из API
                parseIntOrLog(ad.param_12867, "completion_date", po.details);
            } else {
                unprocessedFieldsInfo.push({ field: "completion_date", reason: "param_12867 (Срок сдачи) отсутствует для новостройки." });
            }

            // construction_stage (Стадия строительства)
            // 1: "Построен, но не сдан", 2: "Строится", 3: "Сдан"
            // Выводим из completion_date. Это упрощенная логика.
            if (po.details.completion_date) {
                const currentYear = new Date().getFullYear();
                const currentQuarter = Math.floor(new Date().getMonth() / 3) + 1;
                // Предполагаем, что completion_date это год (2023) или год и квартал (20231 для 1 кв 2023)
                let deliveryYear = po.details.completion_date;
                let deliveryQuarter = 0; // 0 если не указан

                const complDateStr = String(po.details.completion_date);
                if (complDateStr.length > 4 && (complDateStr.includes("кв") || complDateStr.match(/\d{4}[1-4]$/))) {
                    // Например "1 кв. 2024" или "20241"
                    const yearMatch = complDateStr.match(/(\d{4})/);
                    const quarterMatch = complDateStr.match(/([1-4])\s*кв/) || complDateStr.match(/\d{4}([1-4])$/);
                    if (yearMatch) deliveryYear = parseInt(yearMatch[0]);
                    if (quarterMatch) deliveryQuarter = parseInt(quarterMatch[1]);
                } else if (complDateStr.length === 4) {
                    deliveryYear = parseInt(complDateStr);
                }


                if (deliveryYear < currentYear || (deliveryYear === currentYear && deliveryQuarter > 0 && deliveryQuarter < currentQuarter)) {
                    po.details.construction_stage = 3; // Сдан
                } else if (deliveryYear > currentYear || (deliveryYear === currentYear && deliveryQuarter >= currentQuarter)) {
                    po.details.construction_stage = 2; // Строится
                } else {
                    // Если год сдачи текущий, и квартал не указан или прошел - не ясно.
                    // "Построен, но не сдан" - сложно определить автоматически.
                    unprocessedFieldsInfo.push({ field: "construction_stage", value: po.details.completion_date, reason: "Не удалось точно определить стадию (возможно 'Построен, но не сдан')." });
                }
            } else {
                unprocessedFieldsInfo.push({ field: "construction_stage", reason: "completion_date отсутствует, стадия не определена." });
            }

            // apartment_finish (Отделка квартиры для новостройки)
            // 1: "Без отделки", 2: "Черновая", 3: "Чистовая", 4: "Предчистовая", 5: "С ремонтом"
            const p2RepairNew = getP2Val("О квартире.Ремонт") || getP2Val("О квартире.Отделка");
            if (p2RepairNew && typeof p2RepairNew === 'string') {
                const finishLower = p2RepairNew.toLowerCase();
                if (finishLower.includes("без отделки")) po.details.apartment_finish = 1;
                else if (finishLower.includes("черновая")) po.details.apartment_finish = 2;
                else if (finishLower.includes("чистовая")) po.details.apartment_finish = 3;
                else if (finishLower.includes("предчистовая") || finishLower.includes("white box")) po.details.apartment_finish = 4;
                else if (finishLower.includes("с ремонтом") || finishLower.includes("евро") || finishLower.includes("дизайнерский")) po.details.apartment_finish = 5;
                else {
                    unprocessedFieldsInfo.push({ field: "apartment_finish", value: p2RepairNew, reason: "Неизвестный тип отделки." });
                }
            } else {
                unprocessedFieldsInfo.push({ field: "apartment_finish", reason: "Информация об отделке не найдена." });
            }
        }

        // --- Цены и условия сделки/аренды ---
        if (po.details._mainDealType === 1) { // Продажа
            parseFloatOrLog(ad.price, "price", po.details);

            // mortgage_possible (Ипотека)
            const p2Mortgage = getP2Val("О квартире.Вид сделки") || getP2Val("О квартире.Ипотека");
            if (p2Mortgage && typeof p2Mortgage === 'string') {
                if (p2Mortgage.toLowerCase().includes("возможна ипотека") || p2Mortgage.toLowerCase().includes("ипотека")) {
                    po.details.mortgage_possible = 1; // Возможна
                } else {
                    // po.details.mortgage_possible = 2; // Нет (если явно указано "нет")
                    unprocessedFieldsInfo.push({ field: "mortgage_possible", value: p2Mortgage, reason: "Формулировка не позволяет однозначно сказать 'да' или 'нет'." });
                }
            }

            // sale_type (Тип продажи для вторички)
            if (po.details.apartment_type === 1) { // Только для вторички
                const p2SaleType = getP2Val("О квартире.Способ продажи");
                if (p2SaleType && typeof p2SaleType === 'string') {
                    const stLower = p2SaleType.toLowerCase();
                    if (stLower.includes("свободная")) po.details.sale_type = 1;
                    else if (stLower.includes("альтернативная")) po.details.sale_type = 2;
                    else {
                        unprocessedFieldsInfo.push({ field: "sale_type", value: p2SaleType, reason: "Неизвестный тип продажи." });
                    }
                }
            }

        } else if (po.details._mainDealType === 2) { // Аренда
            if (po.details._rent_type === 1) { // Долгосрочная
                parseFloatOrLog(ad.price, "rent_in_month", po.details);

                // rent_period (Срок аренды: "Несколько месяцев" / "От года")
                // ad.param_2016 = "На длительный срок". Конкретизировать сложно.
                // По умолчанию ставим "От года" для "На длительный срок".
                po.details.rent_period = 2; // От года
                // Если в description есть "на несколько месяцев", можно изменить на 1.
                if (po.description && po.description.toLowerCase().includes("на несколько месяцев")) {
                    po.details.rent_period = 1;
                }


                // pay_by_meter (По счетчикам платит)
                // 1: Собственник, 2: Арендатор
                // Очень сложно определить автоматически. Искать в описании "счетчики включены/оплачиваются отдельно".
                const descLower = (po.description || "").toLowerCase();
                if (descLower.includes("счетчики оплачиваются арендатором") || descLower.includes("счетчики отдельно") || descLower.includes("ку отдельно")) {
                    po.details.pay_by_meter = 2;
                } else if (descLower.includes("счетчики включены") || descLower.includes("всё включено")) {
                    po.details.pay_by_meter = 1;
                } else {
                    unprocessedFieldsInfo.push({ field: "pay_by_meter", reason: "Не удалось определить из описания." });
                }

                // prepayment (Предоплата)
                // 1: "За 1 месяц", 2: "2", 3: "3", 4: "4+"
                // Тоже сложно. Искать в описании "предоплата за X месяцев"
                const prepaymentMatch = descLower.match(/предоплат\w*\s*(?:за)?\s*(\d+)\s*месяц/);
                if (prepaymentMatch && prepaymentMatch[1]) {
                    const months = parseInt(prepaymentMatch[1]);
                    if (months === 1) po.details.prepayment = 1;
                    else if (months === 2) po.details.prepayment = 2;
                    else if (months === 3) po.details.prepayment = 3;
                    else if (months >= 4) po.details.prepayment = 4;
                } else {
                    unprocessedFieldsInfo.push({ field: "prepayment", reason: "Не удалось определить из описания." });
                }


            } else if (po.details._rent_type === 2) { // Посуточная
                parseFloatOrLog(ad.price, "rent_per_day", po.details);
            }

            // deposit (Залог)
            if (ad.param_6866) { // "Залог" из API
                const depositVal = String(ad.param_6866);
                if (depositVal.toLowerCase() === "без залога") {
                    po.details.deposit = 0;
                } else if (depositVal.includes("месяца") && po.details.rent_in_month) {
                    const factorMatch = depositVal.match(/([\d.,]+)/);
                    if (factorMatch && factorMatch[1]) {
                        const factor = parseFloat(factorMatch[1].replace(',', '.'));
                        po.details.deposit = factor * po.details.rent_in_month;
                    }
                } else {
                    parseFloatOrLog(depositVal, "deposit", po.details); // Если просто число (сумма)
                }
            } else {
                const p2Deposit = getP2Val("О квартире.Залог") || getP2Val("Условия аренды.Залог"); // Пример, если бы было
                if (p2Deposit) {
                    parseFloatOrLog(p2Deposit, "deposit", po.details);
                } else {
                    unprocessedFieldsInfo.push({ field: "deposit", reason: "param_6866 (Залог) отсутствует или не удалось обработать." });
                }
            }

            // conditions_rent_room (Условия проживания: Можно с детьми / с животными)
            po.details.conditions_rent_room = [];
            const p2Conditions = (getP2Val("О квартире.Условия проживания") || po.description || "").toLowerCase();
            if (p2Conditions.includes("можно с детьми") || p2Conditions.includes("с детьми разрешено")) {
                po.details.conditions_rent_room.push(1);
            }
            if (p2Conditions.includes("можно с животными") || p2Conditions.includes("с животными разрешено") || p2Conditions.includes("питомцами")) {
                po.details.conditions_rent_room.push(2);
            }
            if (po.details.conditions_rent_room.length === 0) delete po.details.conditions_rent_room;
        }

        // Добавление информации о необработанных/пропущенных полях, если есть
        if (ad.params2 && ad.params2["О доме"] && ad.params2["О доме"]["Двор"]) {
            if (ad.params2["О доме"]["Двор"].toLowerCase().includes("детская площадка") ||
                ad.params2["О доме"]["Двор"].toLowerCase().includes("спортивная площадка")) {
                unprocessedFieldsInfo.push({ field: "Инфраструктура двора", value: ad.params2["О доме"]["Двор"], reason: "Пропущено согласно заданию (детская/спортивная площадка)." });
            }
        }
        if (ad.gk_params) {
            unprocessedFieldsInfo.push({ field: "gk_params", reason: "Пропущено согласно заданию." });
        }


    } else {
        // logger.log('Объявление не является квартирой (cat2_id !== 2), пропускаем детальную обработку.');
        unprocessedFieldsInfo.push({ field: "Общая категория", reason: `Объявление не квартира (cat2_id: ${ad.cat2_id}), обработка не производилась.` });
        // return null; // или вернуть po с минимальным набором, если нужно
    }


    //Гаражи и машиноместа
    if (ad.cat2_id === 6) {
        logger.log('Гаражи и машиноместа');
        po.details.subcategoryId = 643009
        po.details.categoryId = 6430

        if (ad.nedvigimost_type === 'Продам') {
            po.saleType = "sale"
        } else if (ad.nedvigimost_type === 'Сдам') {
            po.saleType = "rent"
        }

        // details

        po.details.jsonFileName = "garage_ru_ru.json"

        logger.log('🏀 ad.nedvigimost_type_id', ad.nedvigimost_type_id);
        if (ad.nedvigimost_type_id === "1") {
            po.details._mainDealType = 1
        } else if (ad.nedvigimost_type_id === "2") {
            po.details._mainDealType = 2
        }
        if (ad.nedvigimost_type_id === 1) {
            po.details._mainDealType = 1
        } else if (ad.nedvigimost_type_id === 2) {
            po.details._mainDealType = 2
        }

        if (ad.nedvigimost_type === 'Продам') {
            po.details.total_area = ad.param_4821
        }

        if (ad.nedvigimost_type === 'Сдам') {
            po.details.total_area = parseInt(ad.param_4844)
        }



        logger.log('🏀 po.details._mainDealType', po.details._mainDealType);
        po.details.countryCodeISO = "RU"
        if (ad.param_4782 === "Гараж") {
            po.details.garage_type_category = 2
        } else if (ad.param_4782 === "Машиноместо") {
            po.details.garage_type_category = 1
        }
        else if (ad.param_4782 === "Бокс") {
            po.details.garage_type_category = 3
        }


        po.colleagues = "none"

    }

    // Земельные участки
    if (ad.cat2_id === 5) {
        logger.log('Обработка земельных участков');
        po.details.subcategoryId = 643008
        po.details.categoryId = 6430

        po.details.jsonFileName = "land_ru_ru.json"

        if (ad.nedvigimost_type === 'Продам') {
            po.saleType = "sale"
            po.details._mainDealType = 1
        } else if (ad.nedvigimost_type === 'Сдам') {
            po.saleType = "rent"
            po.details._mainDealType = 2
        }

        if (ad.param_4313 === "Поселений (ИЖС)") {
            po.details.land_status = 1
        } else if (ad.param_4313 === "ДНП") {
            po.details.land_status = 2
        } else if (ad.param_4313 === "Садоводство") {
            po.details.land_status = 3
        } else if (ad.param_4313 === "Фермерское хозяйство") {
            po.details.land_status = 4
        } else if (ad.param_4313 === "ЛПХ") {
            po.details.land_status = 5
        }

        if (ad.param_4616) {
            po.details.land_area = parseFloat(ad.param_4616).toFixed(2)
        }
    }

    // Комнаты и доли
    if (ad.cat2_id === 3) {
        logger.log('Обработка комнат и долей');
        po.details.subcategoryId = 643003
        po.details.categoryId = 6430
        po.details.jsonFileName = "partial_apartment_ru_ru.json"

        if (ad.nedvigimost_type === 'Продам') {
            po.saleType = "sale"
            po.details._mainDealType = 1
        } else if (ad.nedvigimost_type === 'Сдам') {
            po.saleType = "rent"
            po.details._mainDealType = 2
        }

        if (ad.cat2 === "Комнаты") {
            po.details.sale_type_partial_ap = 1
        } else if (ad.cat2 === "Доля") {
            po.details.sale_type_partial_ap = 2
        }
        // type_construction (Тип дома где продается комната) - только для продажи
        if (po.details._mainDealType === 1) {
            const typeConstructionMap = {
                "кирпичный": 1, "монолитный": 2, "панельный": 3, "блочный": 4,
                "монолитно-кирпичный": 5, /* "сталинский": 6, */ "деревянный": 7
            };
            let typeConstructionSource = ad.param_2567; // Для продажи
            const p2TypeConstruction = getP2Val("О доме.Тип дома");
            if (p2TypeConstruction) typeConstructionSource = p2TypeConstruction;

            if (typeConstructionSource) {
                const tcKey = String(typeConstructionSource).toLowerCase();
                if (typeConstructionMap[tcKey]) {
                    po.details.type_construction = typeConstructionMap[tcKey];
                } else {
                    unprocessedFieldsInfo.push({ field: "type_construction", value: typeConstructionSource, reason: "Неизвестное значение." });
                }
            }
        }

        // floor (Этаж)
        if (ad.param_2636) {
            po.details.floor = parseInt(ad.param_2636);
        }
        // total_floors (Этажность)
        if (ad.param_2736) {
            po.details.total_floors = parseInt(ad.param_2736);
        }
        // количество комнат во всей квартире
        if (ad.param_2545) {
            po.details.roomsId = parseInt(ad.param_2545);
        }


        // площадь комнат
        if (ad.param_2836) {
            po.details.rooms_area_in_partial_ap_sell_room = parseFloat(ad.param_2836).toFixed(2);
        }
        // срок аренды
        if (ad.param_2574) {
            if (ad.param_2574 === "На длительный срок") {
                po.details._rent_type = 1;
            } else if (ad.param_2574 === "Посуточно") {
                po.details._rent_type = 2;
            }
        }
        // Залог
        if (ad.param_7184) {
            if (ad.param_7184 === "Нет") {
                po.details.deposit = 0;
            } else if (ad.param_7184 === "Есть") {
                po.details.deposit = 1;
            }
        }
        // комнаты в квартире
        if (ad.param_2603) {
            po.details.roomsId = parseInt(ad.param_2603);
        }
        // этаж
        if (ad.param_2838) {
            po.details.floor = parseInt(ad.param_2838);
        }
        // этажность
        if (ad.param_2938) {
            po.details.total_floors = parseInt(ad.param_2938);
        }
        // площадь комнаты
        if (ad.param_3038) {
            po.details.room_area = parseFloat(ad.param_3038).toFixed(2);
        }




    }

    // Дома, дачи, коттеджи
    if (ad.cat2_id === 4) {
        logger.log('Обработка домов, дач и коттеджей');
        po.details.subcategoryId = 643004
        po.details.categoryId = 6430
        po.details.jsonFileName = "house_ru_ru.json"

        if (ad.nedvigimost_type === 'Продам') {
            po.saleType = "sale"
            po.details._mainDealType = 1
        } else if (ad.nedvigimost_type === 'Сдам') {
            po.saleType = "rent"
            po.details._mainDealType = 2
        }

        // Вид объекта
        if (ad.param_3042) {
            if (ad.param_3042 === "Дом") {
                po.details.house_type_category = 1;
            }
            else if (ad.param_3042 === "Дача") {
                po.details.house_type_category = 1;
            }
            else if (ad.param_3042 === "Коттедж") {
                po.details.house_type_category = 2;
            } else if (ad.param_3042 === "Таунхаус") {
                po.details.house_type_category = 3;
            } else if (ad.param_3042 === "Часть дома") {
                po.details.house_type_category = 4;
            }
        }
        // Материал стен
        if (ad.param_3843) {
            if (ad.param_3843 === "Кирпич") {
                po.details.type_construction = 1;
            } else if (ad.param_3843 === "Брус") {
                po.details.type_construction = 2;
            } else if (ad.param_3843 === "Бревно") {
                po.details.type_construction = 3;
            } else if (ad.param_3843 === "Пеноблоки") {
                po.details.type_construction = 9;
            } else if (ad.param_3843 === "Сэндвич-панели") {
                po.details.type_construction = 10;
            } else if (ad.param_3843 === "Экспериментальные материалы") {
                po.details.type_construction = 11;
            }
        }

        // площадь дома
        if (ad.param_4014) {
            po.details.total_area = parseFloat(ad.param_4014).toFixed(2);
        }

        // площадь участка
        if (ad.param_4015) {
            po.details.land_area = parseFloat(ad.param_4015).toFixed(2);
        }

        if (ad.param_3042) {
            po.details.house_type = ad.param_3042;
        }
        if (ad.param_3837) {
            po.details.total_floors = parseInt(ad.param_3837);
        }
        if (ad.param_3843) {
            po.details.wall_material = ad.param_3843;
        }
        if (ad.param_3852) {
            po.details.distance_to_city = parseInt(ad.param_3852);
        }
        if (ad.param_4014) {
            po.details.total_area = parseFloat(ad.param_4014).toFixed(2);
        }

        // аренда
        // Вид объекта
        if (ad.param_3428) {
            if (ad.param_3428 === "Дом") {
                po.details.house_type_category = 1;
            }
            else if (ad.param_3428 === "Дача") {
                po.details.house_type_category = 1;
            }
            else if (ad.param_3428 === "Коттедж") {
                po.details.house_type_category = 2;
            } else if (ad.param_3428 === "Таунхаус") {
                po.details.house_type_category = 3;
            } else if (ad.param_3428 === "Часть дома") {
                po.details.house_type_category = 4;
            }
        }
        // срок аренды 
        if (ad.param_3433) {
            if (ad.param_3433 === "На длительный срок") {
                po.details._rent_type = 1;
            } else if (ad.param_3433 === "Посуточно") {
                po.details._rent_type = 2;
            }
        }
        // Материал стен
        if (ad.param_4022) {
            if (ad.param_4022 === "Кирпич") {
                po.details.type_construction = 1;
            } else if (ad.param_4022 === "Брус") {
                po.details.type_construction = 2;
            } else if (ad.param_4022 === "Бревно") {
                po.details.type_construction = 3;
            } else if (ad.param_4022 === "Пеноблоки") {
                po.details.type_construction = 9;
            } else if (ad.param_4022 === "Сэндвич-панели") {
                po.details.type_construction = 10;
            } else if (ad.param_4022 === "Экспериментальные материалы") {
                po.details.type_construction = 11;
            }


        }
        if (ad.params2?.["Об объекте"]?.["Материал стен"] === "Газоблоки") {
            po.details.type_construction = 7;
        }

        if (ad.param_4193) {
            po.details.total_area = parseFloat(ad.param_4193).toFixed(2);
        }

        if (ad.param_4194) {
            po.details.land_area = parseFloat(ad.param_4194).toFixed(2);
        }






    }


    // Коммерческая недвижимость
    if (ad.cat2_id === 7) {
        logger.log('Обработка коммерческой недвижимости');
        po.details.categoryId = 6431
        
        if (ad.param_4867 === "Продам") {
            po.saleType = "sale"
            po.details._mainDealType = 1
        } else if (ad.param_4867 === "Сдам") {
            po.saleType = "rent"
            po.details._mainDealType = 2
        }
        
        if (ad.param_4869 === "Помещение свободного назначения") {
            po.details.jsonFileName = "free_purpose_ru_ru.json"
            po.details.subcategoryId = 6430013
        }
        if (ad.param_4869 === "Здание") {
            po.details.jsonFileName = "building_ru_ru.json"
            po.details.subcategoryId = 6430011
        }
        if (ad.param_4869 === "Производственное помещение") {
            po.details.jsonFileName = "production_ru_ru.json"
            po.details.subcategoryId = 6430014
        }
        if (ad.param_4869 === "Складское помещение") {
            po.details.jsonFileName = "warehouse_ru_ru.json"
            po.details.subcategoryId = 6430015
        }
        if (ad.param_4869 === "Торговое помещение") {
            po.details.jsonFileName = "shop_area_ru_ru.json"
            po.details.subcategoryId = 6430012
        }
        if (ad.param_4869 === "Коммерческая земля") {
            po.details.jsonFileName = "commercial_land_ru_ru.json"
            po.details.subcategoryId = 6430017
        }

        if (ad.param_4920) {
            po.details.total_area = parseFloat(ad.param_4920).toFixed(2);
        }

        if (ad.param_12868) {
            po.details.floor = parseInt(ad.param_12868);
        }
        if (ad.param_12869) {
            po.details.total_floors = parseInt(ad.param_12869);
        }
        
        if (ad.param_12883) {
            po.details.total_area = parseFloat(ad.param_12883).toFixed(2);
        }

        if (ad.param_4872) {
            if(ad.param_4872 === "A") {
                po.details.building_class = 1;
            } else if (ad.param_4872 === "B") {
                po.details.building_class = 2;
            } else if (ad.param_4872 === "C") {
                po.details.building_class = 3;
            } else if (ad.param_4872 === "D") {
                po.details.building_class = 4;
            }
        }
    }

    if (unprocessedFieldsInfo.length > 0) {
        // logger.warn(`Для объявления id=${ad.id} есть необработанные/пропущенные поля:`, unprocessedFieldsInfo);
        // Можно добавить это в какой-то служебный ключ, если нужно передавать дальше
        po.processing_notes = unprocessedFieldsInfo;
    }


    // logger.log('prepareParseObject result po:', po);
    return po;
};
